import React from "react";
import { Modal, Button, Select } from "../..";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import styles from "./index.module.css";
import {
  RESCHEDULE_ROUNDTRIP_HEADING,
  RESCHEDULE_ROUNDTRIP_POPUP_TITLE,
  RIDE_RESCHEDULED_REASONS,
} from "../../../constants/constants";
import { RidePickUpInfo } from "../../common/RideDetails/RideDetailsPartials/RidePickUpInfo";
import { RideDestinationInfo } from "../../common/RideDetails/RideDetailsPartials/RideDestinationInfo";

export const ConfirmRescheduleRideModal = ({
  ride,
  handleConfirm,
  handleCancel,
}) => {
  // Validation schema for Formik
  const validationSchema = Yup.object({
    reason: Yup.string().required("Please select a reason for rescheduling."),
  });

   
  const handleSubmit = (value) => {
   // console.log("Selected reason:", value.reason); // Log the selected reason
    handleConfirm(value.reason); // Pass the selected reason to the confirm handler
  
  };
  const initialValues = {
    reason: undefined
  };

  return (
    <Modal
      visible={true}
      onCancel={handleCancel}
      closable
      width="auto"
      bodyStyle={{ padding: "15px" }}
      title={
        ride?.connectedLeg
          ? RESCHEDULE_ROUNDTRIP_POPUP_TITLE
          : `Reschedule Ride Request – ID ${ride?.seqId}`
      }
    >
      <>
      <h3 className={styles.text_center}>One or both legs of this ride will be rescheduled. Do you want to proceed?</h3>
        {ride?.connectedLeg && (
          <div className={styles.routes}>
           
             

            <RidePickUpInfo
              pickupAddressDetails={ride?.pickupAddressDetails}
              destinationAddress={ride?.destinationAddress}
              pickUpDate={ride?.pickUpDate}
              riderDescription={ride?.riderDescription}
              pickUpDateLowerLimit={ride?.pickUpDateLowerLimit}
              isPickUpDateFlexible={ride?.isPickUpDateFlexible}
              tcEstimatedPickUpDate={ride?.tcEstimatedPickUpDate}
              securityGate={ride?.pickUpSecurityGateDetails}
              flightInfo={ride?.flightInfo}
              appointmentDate={ride?.appointmentDate}
              isRecurringRide={ride?.isRecurring}
              leg={ride?.leg}
              seqId={ride?.seqId}
            />

            <div className={styles.destionationRouteInfo}>
              <RideDestinationInfo
                destinationAddress={ride?.destinationAddress}
                originAddress={ride?.pickupAddressDetails}
                showRoundtripInfo={ride?.isRoundtrip && ride?.leg}
                securityGate={ride?.destinationSecurityGateDetail}
                returnTime={ride?.connectedLeg?.pickUpDate}
                returnTimeLowerLimit={ride?.returnTimeLowerLimit}
                isReturnDateFlexible={ride?.isReturnDateFlexible}
                leg={ride?.connectedLeg?.leg}
                seqId={ride?.connectedLeg?.seqId}
              />
            </div>
          </div>
        )}

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
         validateOnMount
        >
          {({ values,  isValid }) => (
            <Form>
              <div className={styles.modalContent}>
                <p className={styles.modalDescription}>
                  Please select a reason for rescheduling the ride:
                </p>
                <div className={styles.selectGroup}>
                <Select
                    name="reason"
                    options={RIDE_RESCHEDULED_REASONS}
                    value={values.reason}
                    
                    placeholder="Select a reschedule reason"
                  />
                </div>
                <div className={styles.modalBtns}>
                  <div>
                    <Button
                      myClassName={styles.navigationBtn}
                      onClick={() => handleSubmit(values)}
                      disabled={!isValid} // Disable if the form is invalid
                    >
                      OK
                    </Button>
                  </div>
                  <div>
                    <Button
                      myClassName={styles.navigationBtn}
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </>
    </Modal>
  );
};
